<template>
    <div class="cover-konten">
        <div v-if="status" class="available">
            <div class="konten-ada">
                <h2>{{surat}}</h2>
                <p>{{ arti }}</p>
                <button class='btn-membaca' type='button'><router-link v-bind:to="link">Lanjutkan Membaca</router-link></button>
            </div>
        </div>
        <div v-else class="unavailable">
            <div id='konten-unavailable'>
                <img src='../assets/gambar/kosong.svg' alt='Kosong'/>
                <br/>
                
                <br/>
                <button class="btn-membaca" type='button'><router-link to="/">Baca Al - Qur'an</router-link></button>
            </div>
        </div>
    </div>
</template>
<style scoped>
.available 
{
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.konten-ada 
{
    width: 100%;
    text-align: center;
}
.unavailable 
{
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
#konten-unavailable 
{
    width: 100%;
    height: auto;
    text-align: center;
}
#konten-unavailable img 
{
    width: 300px;
}
#konten-unavailable h5{
    font-weight: bold;
    color: gray;
}
.btn-membaca
{
    width: 20%;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #8bcc8b;
    color: white;
    background-color: #8bcc8b;
    margin-top: 3%;
    transition: 0.3s;
}
.btn-membaca:hover{
    box-shadow: 0px 6px 20px 1px #8bcc8b;
}
.btn-membaca:focus{
    box-shadow: 0px 10px 20px 3px #8bcc8b;
    outline: none;
}
.btn-membaca a{
    color: white;
    text-decoration: none;
}
@media screen and (max-width: 780px)
{
    .btn-membaca
    {
        width: 80%;
    }
}
</style>
<script>
import { Write, Read } from './Cookies';

export default {
    data(){
        return {
            status: false,
            surat: '',
            arti: '',
            nomor: '',
            link: '',
        }
    },

    created(){
        const hasil = new Read('surat').baca();
        if( hasil.length > 0 )
        {
            this.status = true;
            const Nama = new Read('arti').baca();
            const surat = new Read('surat').baca();
            const Nomor = new Read('nomor').baca();
            this.surat = surat;
            this.arti = Nama;
            this.nomor = Nomor;
            this.link = "/baca/" + Nomor + "/" + surat + "/" + Nama;
        }
    }

}
</script>